import { type UseQueryResult } from '@tanstack/react-query';
import { plainToClass } from 'class-transformer';

import { journeysApi } from 'api';
import { type ApiQueryOptions } from 'hooks/api/queryHelper';
import { useProtectedQuery } from 'hooks/api/useProtectedQuery';
import { Journey } from 'models/Journey';

const fetchJourney = async (id: number) => {
  const [error, response] = await journeysApi.fetchJourney(id);

  if (error) {
    throw error;
  } else {
    return response;
  }
};

const useFetchJourney = (id: number, options: ApiQueryOptions = {}) => {
  return useProtectedQuery({
    queryKey: ['journey', id],
    queryFn: () => fetchJourney(id),
    select: (data) => plainToClass(Journey, data),
    ...options,
  }) as UseQueryResult<Journey>;
};

export default useFetchJourney;
